import script from "./Record.vue?vue&type=script&setup=true&lang=js"
export * from "./Record.vue?vue&type=script&setup=true&lang=js"

import "./Record.vue?vue&type=style&index=0&id=701a2e7a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-701a2e7a"]])

export default __exports__